$(function() {
  const videoTriggers = document.querySelectorAll('[data-video-trigger]');
  Array.from(videoTriggers).forEach(node => {
    const videoId = node.getAttribute('data-video-trigger');

    if (!videoId) {
      console.warn(`missing video id on video trigger: ${videoId}`);
    }


    node.addEventListener('click', e => {
      e.preventDefault();

      // the video lib rewrap the whole thumbnail block so we cannot
      // save the id once and for all
      const videoTrigger = document.getElementById(`video-trigger-${videoId}`);

      if (!videoTrigger) console.warn(`missing video in page for id: ${videoId}`);

      videoTrigger.click()
      return false;
    });
  });
});
